/** @format */
import { client } from '@toucan/client/global/axios';
import { Taxonomy } from '@toucan/client/global/taxonomy';

export async function getCategoryTree(): Promise<Taxonomy> {
    const response = await client.get('/taxonomy/category');
    return response.data;
}

export async function getBrandTree(): Promise<Taxonomy> {
    const response = await client.get('/taxonomy/brand');
    return response.data;
}
